import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { Navigate } from 'react-router-dom'
import { AuthLayout } from '@/layouts/auth';
import { getRestrictedRedirectPath, isReferralAttorney, useAuthContext } from '@/auth';
import { ScreenLoader } from '@/components/loaders';

const Login = lazy(() => import('./pages/jwt/Login').then((module) => ({ default: module.Login })));
const SuperAdminLogin = lazy(() => import('./pages/jwt/SuperAdminLogin').then((module) => ({ default: module.SuperAdminLogin })));
const TwoFactorAuth = lazy(() => import('./pages/jwt/TwoFactorAuth').then((module) => ({ default: module.TwoFactorAuth })));
const CheckEmail = lazy(() => import('./pages/jwt/CheckEmail').then((module) => ({ default: module.CheckEmail })));
const ResetPassword = lazy(() => import('./pages/jwt/reset-password/ResetPassword').then((module) => ({ default: module.ResetPassword })));
const ResetPasswordEnterEmail = lazy(() => import('./pages/jwt/reset-password/ResetPasswordEnterEmail').then((module) => ({ default: module.ResetPasswordEnterEmail })));
const ResetPasswordCheckEmail = lazy(() => import('./pages/jwt/reset-password/ResetPasswordCheckEmail').then((module) => ({ default: module.ResetPasswordCheckEmail })));
const ResetPasswordChange = lazy(() => import('./pages/jwt/reset-password/ResetPasswordChange').then((module) => ({ default: module.ResetPasswordChange })));
const ResetPasswordChanged = lazy(() => import('./pages/jwt/reset-password/ResetPasswordChanged').then((module) => ({ default: module.ResetPasswordChanged })));
const SetPassword = lazy(() => import('./pages/jwt/SetPassword').then((module) => ({ default: module.SetPassword })));

const AuthPage = () => {
  const { auth, loading } = useAuthContext();
  if (loading) {
    return <ScreenLoader />;
  }

  if (isReferralAttorney(auth?.user)) {
    return <Navigate to="/account/home/referral-attorney" replace />;
  }

  const restrictedRedirectPath = getRestrictedRedirectPath(auth?.user);
  if (auth && restrictedRedirectPath) {
    return <Navigate to={restrictedRedirectPath} replace />;
  }

  if (auth) {
    return <Navigate to="/" replace />;
  }

  // Auth layout for Protected Routes
  // route for this layout -> /auth/*
  return (
    <Suspense fallback={<ScreenLoader />}>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/admin/login" element={<SuperAdminLogin />} />
          <Route path="/2fa" element={<TwoFactorAuth />} />
          <Route path="/check-email" element={<CheckEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/enter-email" element={<ResetPasswordEnterEmail />} />
          <Route path="/reset-password/check-email" element={<ResetPasswordCheckEmail />} />
          <Route path="/reset-password/change" element={<ResetPasswordChange />} />
          <Route path="/reset-password/changed" element={<ResetPasswordChanged />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="*" element={<Navigate to="/error/404" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
export { AuthPage };
